export const OFFICE_LED_LIGHTING = () => {
    return (
        <p>
            Lighting has a significant impact on productivity, mood, and the overall well-being of those using the space. 
            We offer lighting installation and maintenance services.
        </p>
    )
};

export const COMMERCIAL_ELECTRICAL_WIRING = () => {
    return (
        <p>
            We specialize in handling the wiring, lighting, and other electrical components for commercial projects, ensuring reliable and high-quality service with no room for mistakes.
        </p>
    )
};

export const COMMUNICATIONS = () => {
    return (
        <p>
            Communications systems are essential for both new and existing commercial buildings. After all, they are necessary for conducting business. 
            We can install the appropriate components to ensure that communication is simple.
        </p>
    )
};

export const PANEL_REP_UPGRADES = () => {
    return (
        <p>
            If the electrical infrastructure of your business is outdated, requires more capacity for your expanding business, or if your existing sub-panel needs servicing, Chambers Electrical is here to help. 
            We offer reliable electrical panel upgrades, installation, and maintenance services that you can depend on.
        </p>
    )
};

export const ELECTRICAL_PAN_UPGRADES = () => {
    return (
        <p>
            Upgrading your electrical system can improve safety, increase power, and potentially reduce insurance costs and monthly bills. Insufficient outlets for appliances can lead to fire hazards. 
            Seek assistance from Chambers Electrical for a comprehensive electrical system upgrade, including replacing the line side service entrance cable, grounding and bonding system, meter base, load side service entrance cable, and electric panel.
        </p>
    )
};

export const ELECTRICAL_REPAIR = () => {
    return (
        <p>
            If you're experiencing electrical problems in your home, Chambers Electrical's expert electricians can help identify and fix the issue, whether it's a non-working outlet, flickering lights, or a tripping circuit breaker.
            Need a quick resolution? We also offer emergency electrical services.
        </p>
    )
};

export const INDOOR_LIGHTING = () => {
    return (
        <p>
            Your home is a reflection of who you are. Let your personality shine in every corner of your home.
            Whether you prefer functionality and efficiency or a high-end and distinctive style, the appropriate lighting can make a significant difference in the ambiance of any room. 
            The right indoor lighting has the power to transform a plain space into something extraordinary.
            Trust the expertise of the professional electricians at Chambers Electrical to bring light into your living space and create a captivating atmosphere.
        </p>
    )
};

export const ELECTRICAL_VEH_CHG_INST = () => {
    return (
        <p>
            If you are thinking about getting one of the newest EV charging stations installed, we can provide that service. 
            Whether you already drive an electric vehicle or are planning to do so, we offer a convenient and affordable way to charge your vehicle. 
            Save time by not having to search for charging stations when we can bring the technology to you.
        </p>
    )
};

// Job Listings

export const ELECTRICAL_JOB = () => {
    return (
        <div className="job-contain">
            <p>
                At Chambers Electrical, our employees are held to high standards. We value clean images and professionalism in every aspect of our work. We offer competitive compensation to skilled and efficient electricians. The qualifications for this position are as follows:
            </p>
            <ul>
                <li className="dark">New Hires start with PTO. Details given during interview process.</li>
                {/*<li className="dark">$3,000 Signing bonus available for qualifying Electricians</li>*/}
                <li>Customer Services: Electricians will be required to work closely with homeowners, building owners, maintenance workers, and other individuals. It is essential to be friendly, approachable, and possess strong communication skills.</li>
                <li>Attention to Detail: Electrical systems are precise mechanisms. Very careful or precise observation is crucial.</li>
                <li>Time-Management: Electricians are responsible for completing tasks that can range from 30 minutes to multiple days. It is crucial to finish these tasks on time in order to stay on schedule.</li>
                <li>Color Vision: Electricians work with wiring of different colors and need to be able to visually identify them.</li>
                <li>Troubleshooting: Electricians should possess the ability to identify the root cause of problems and approach them with logical thinking to find appropriate solutions.</li>
                <li>Critical Thinking: Electricians must employ critical thinking skills when diagnosing problems and repairing issues.</li>
                <li>Mechanical Skills: Electricians review blueprints and schematics and utilize a variety of tools and diagnostic devices to maintain and install electrical components.</li>
                <li>Some travel in the Virginia area required.</li>
            </ul>
            <h3>Basic Requirements</h3>
            <ul>
                <li>Education: High school or equivalent</li>
                <li>Driver’s License</li>
            </ul>
            <h3>Preferred Requirements</h3>
            <ul>
                <li>Five (5) years of Electrical experience</li>
                <li>Electrical License</li>
            </ul>
            <p>
                If you are willing and able to do the job right and desire to be the best that you can be, let’s make this happen together!
                <br/>
                <br/>
                Please send your resume to <span className="dark">samantha@chamberselectricalrva.com</span> for consideration.
            </p>
        </div>
    )
};

const TextContent = {
    
    OFFICE_LED_LIGHTING,
    COMMERCIAL_ELECTRICAL_WIRING,
    COMMUNICATIONS,
    PANEL_REP_UPGRADES,
    ELECTRICAL_PAN_UPGRADES,
    ELECTRICAL_REPAIR,
    INDOOR_LIGHTING,
    ELECTRICAL_VEH_CHG_INST,
    // Job Listings
    ELECTRICAL_JOB,
}

export default TextContent;